<template>
	<div class="wai">
		<div class="title">
			<div class="blue"></div>
			<div style="flex: 1;">发型师档案</div>
			<el-button @click="goback()" size="small">返 回</el-button>
			<el-button size="small" @click="getlist()">
				<i class="el-icon-refresh"></i> 刷 新
			</el-button>
		</div>
		<div class="demo">
			<div class="demoleft">
				<img :src="user.avatar" />
				<div class="demomsg">
					<div style="margin-top: 15px;">{{user.workerName}}</div>
					<div style="margin-top: 10px;">入职时间: {{user.createTime}}</div>
					<div style="margin-top: 10px;">现任门店: {{user.storeName}}</div>
				</div>
			</div>
			<div class="demoright">
				<div class="demorights">
					<!-- <div>{{usertotal}}</div> -->
					<div>{{summaryList.sumCustomer}}</div>
					<div>累计服务用户数</div>
				</div>
				<div class="demorights">
					<!-- <div>{{ordertotal}}</div> -->
					<div>{{summaryList.sumCount}}</div>
					<div>累计服务订单数</div>
				</div>
				<div class="demorights">
					<!-- <div>￥{{moneytotal}}</div> -->
					<div>￥{{summaryList.sumTotal}}</div>
					<div>累计创收</div>
				</div>
				<div class="demorights">
					<!-- <div>{{membertotal}}</div> -->
					<div>{{summaryList.sumMember}}</div>
					<div>累计开通会员数</div>
				</div>
			</div>
		</div>
		<div class="mouthtable" v-loading="loading">
			<div class="mouthtable_top">
				<div class="mouthtable_top_left">
					<div class="title" style="margin-right: 10px;margin-top: 3px;">
						等级
					</div>
					<el-select v-model="type" @change="getlist()" size="small" style="width: 180px;margin-right:10px;"
						placeholder="全部">
						<el-option v-for="item in options" :key="item.label" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-button size="mini" type="primary" @click="getlist">筛 选</el-button>
					<el-popover placement="top-start" title="说明" width="250" trigger="hover" content="提成非会员10元,会员5元">
						<el-button size="medium" slot="reference" style="margin-left: 10px;">说明</el-button>
					</el-popover>
				</div>
			</div>
			<el-table :cell-style="{'text-align':'center','font-size':'16px'}"
				:header-cell-style="{background:'#F2F2F4','text-align':'center','color':'#6a6a6a','font-size':'18px'}"
				ref="multipleTable" :data="list" tooltip-effect="dark" style="width: 100%">
				<el-table-column prop="month" label="月份"></el-table-column>
				<el-table-column prop="num" label="订单数"></el-table-column>
				<el-table-column prop="badCount" label="差评数"></el-table-column>
				<el-table-column prop="goodCount" label="好评数"></el-table-column>
				<el-table-column prop="turnover" label="业绩目标"></el-table-column>
				<el-table-column prop="total" label="实际业绩"></el-table-column>
				<el-table-column label="业绩达标率" width="110px">
					<template slot-scope="scope">
						{{scope.row.turnoverRate}}%
					</template>
				</el-table-column>
				<el-table-column label="会员销售数" width="110px">
					<template slot-scope="scope">
						{{scope.row.memberNum}}
					</template>
				</el-table-column>
				<el-table-column prop="mbNormal" label="非会员购买澳宝"></el-table-column>
				<el-table-column prop="mbMember" label="会员购买澳宝"></el-table-column>
				<el-table-column prop="libai" label="购买立白"></el-table-column>
				<el-table-column label="提成">
					<template slot-scope="scope">
						{{scope.row.commission | numFilter}}
					</template>
				</el-table-column>
				<el-table-column prop="storeName" label="所在门店"></el-table-column>
				<el-table-column prop="userNum" label="累计客数"></el-table-column>
				<el-table-column label="曾在门店/剪发业绩" width="200">
					<template slot-scope="scope">
						<div v-for="item in scope.row.storeInfo" :key="item.index">
							{{item.storeName}}/￥{{item.total == ''?0:item.total}}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="分值" fixed="right">
					<template slot-scope="scope">
						{{ scope.row.score}}分
					</template>
				</el-table-column>
				<el-table-column prop="level" label="等级" style="color: #0000CC;" fixed="right"></el-table-column>
			</el-table>
			<div class="pagewai" style="text-align: center;">
				<div class="paging">
					<el-pagination @current-change="handlePageChange" @size-change="handleSizeChange" background
						layout="sizes,prev, pager, next" :page-count="pageNo" :page-sizes="[10, 20, 30, 50, 100]"
						:page-size="pageSize" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				user: {},
				loading: false,
				type: "",
				list: [],
				pageNo: 1,
				pageSize: 50,
				total: 0,
				usertotal: "",
				ordertotal: "",
				moneytotal: "",
				membertotal: "",
				options: [{
					value: "",
					label: "全部"
				}, {
					value: "S",
					label: "S"
				}, {
					value: "A",
					label: "A"
				}, {
					value: "B",
					label: "B"
				}, {
					value: "C",
					label: "C"
				}, {
					value: "D",
					label: "D"
				}],
				summaryList: {}
			}
		},
		mounted() {
			this.user = JSON.parse(localStorage.getItem('hairuser'))
			this.getlist()
			this.getSummary()
		},
		filters: {
			numFilter(value) { //不四舍五入
				let realVal = ''
				if (value !== '' && value != null && !isNaN(value)) {
					// 截取当前数据到小数点后三位
					let tempVal = parseFloat(value).toFixed(3)
					realVal = tempVal.substring(0, tempVal.length - 1)
				} else {
					realVal = '/'
				}
				return realVal
			},
			numFilter2(value) { //四舍五入
				let realVal = ''
				if (value !== '' && value != null && !isNaN(value)) {
					// 截取当前数据到小数点后两位
					realVal = parseFloat(value).toFixed(2)
				} else {
					realVal = '/'
				}
				return realVal
			}
		},
		methods: {
			getlist() {
				this.loading = true
				this.$http.get("dWorkerFile/list?workerId=" + this.$route.query.id + "&level=" + this.type +
					"&content=monthDesc" + "&pageNum=" + this.pageNo + "&pageSize=" + this.pageSize).then(res => {
					var list = res.body.data
					// 累计服务用户数
					var usertotal = 0
					// 累计服务订单数
					var ordertotal = 0
					// 累计创收
					var moneytotal = 0
					// 累计会员数
					var membertotal = 0
					var newlists = []
					var s
					var a = []
					for (let i in list) {
						usertotal += list[i].userNum
						ordertotal += list[i].num
						moneytotal += list[i].total
						membertotal += list[i].memberNum
						// console.log(list[i].storeInfo)
						list[i].storeInfo = JSON.parse(list[i].storeInfo)
						// console.log("======")
						// console.log(list[i].storeInfo)
					}
					this.list = list
					this.total = res.body.total
					this.usertotal = usertotal
					this.ordertotal = ordertotal
					this.moneytotal = moneytotal.toFixed(2)
					this.membertotal = membertotal
					this.total = res.body.total
					this.loading = false
				})
			},
			getSummary() {
				this.$http.get("dWorkerFile/summary?workerId=" + this.$route.query.id).then(res => {
					this.summaryList = res.body.data
				})
			},
			goback() {
				this.$router.push({
					path: '/hairfiles',
				})
			},
			handlePageChange(val) {
				this.pageNo = val
				this.getlist()
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.getlist()
			}
		}
	}
</script>

<style lang="less" scoped>
	.wai {
		min-height: 80vh;
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.title2 {
		margin-top: 30px;
		margin-bottom: 30px;
	}

	// /deep/ .el-table_1_column_12  {
	// 	color: #ff0000;
	// 	font-weight: 800;
	// }

	// 第二部分
	.demo {
		display: flex;
		width: 100%;
		height: 166px;
		background: #FFFFFF;
		box-shadow: 2px 2px 4px 2px rgba(102, 102, 102, 0.5);
		margin-top: 8px;
		box-sizing: border-box;
		padding: 20px;

		.demoleft {
			width: 33%;
			display: flex;
			border-right: 1px solid #bcbcbc;

			img {
				width: 105px;
				height: 105px;
				margin-top: 10px;
				border-radius: 50%;
			}

			.demomsg {
				margin-left: 25px;

				div:nth-child(1) {
					font-size: 24px;
					font-family: SourceHanSansCN-Bold, SourceHanSansCN;
					font-weight: bold;
					color: #2D2D2D;
					margin-top: 9px;
				}

				div:nth-child(n+2) {
					margin-top: 5px;
					font-size: 14px;
					font-family: SourceHanSansCN-Normal, SourceHanSansCN;
					font-weight: 400;
					color: #898989;
				}
			}
		}

		.demoright {
			display: flex;
			width: 90%;

			div {
				text-align: center;
				flex: 1;

				div:nth-child(1) {
					font-size: 36px;
					font-family: SourceHanSansCN-Bold, SourceHanSansCN;
					font-weight: bold;
					color: #2D2D2D;
					margin-top: 25px;
				}

				div:nth-child(2) {
					font-size: 16px;
					font-family: SourceHanSansCN-Normal, SourceHanSansCN;
					font-weight: 400;
					color: #0D0D0D;
				}
			}
		}
	}

	// 
	.mouthtable {
		margin-top: 25px;
		width: 100%;
		height: auto;
		background: #FFFFFF;
		box-shadow: 2px 2px 4px 2px rgba(102, 102, 102, 0.5);
		box-sizing: border-box;
		padding: 20px;

	}

	.mouthtable_top {
		margin-bottom: 10px;
		display: flex;

		.mouthtable_top_left {
			display: flex;
			flex: 1;
		}
	}
</style>